'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _toConsumableArray = require('@babel/runtime-corejs3/helpers/toConsumableArray');
var _typeof = require('@babel/runtime-corejs3/helpers/typeof');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');
var _Set = require('@babel/runtime-corejs3/core-js-stable/set');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
var _Array$from = require('@babel/runtime-corejs3/core-js-stable/array/from');
var _Symbol = require('@babel/runtime-corejs3/core-js-stable/symbol');
var _getIteratorMethod = require('@babel/runtime-corejs3/core-js/get-iterator-method');
var _Array$isArray = require('@babel/runtime-corejs3/core-js-stable/array/is-array');
var graphchart_data_link = require('./graphchart.data.link.js');
var graphchart_data_node = require('./graphchart.data.node.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);
var _Set__default = /*#__PURE__*/_interopDefaultLegacy(_Set);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);
var _Array$from__default = /*#__PURE__*/_interopDefaultLegacy(_Array$from);
var _Symbol__default = /*#__PURE__*/_interopDefaultLegacy(_Symbol);
var _getIteratorMethod__default = /*#__PURE__*/_interopDefaultLegacy(_getIteratorMethod);
var _Array$isArray__default = /*#__PURE__*/_interopDefaultLegacy(_Array$isArray);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof _Symbol__default["default"] && _getIteratorMethod__default["default"](r) || r["@@iterator"]; if (!t) { if (_Array$isArray__default["default"](r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { var _context13; if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = _sliceInstanceProperty__default["default"](_context13 = {}.toString.call(r)).call(_context13, 8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from__default["default"](r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var gquery = {
  isNode: function isNode(obj) {
    var result = true;
    if (_typeof__default["default"](obj) !== "object" || obj === null) {
      return false;
    } else {
      result = result && typeof obj["v_id"] === "string";
      result = result && typeof obj["v_type"] === "string";
      // result = result && typeof obj['v_set'] === 'string';
      result = result && (_typeof__default["default"](obj["v"]) === "object" || _typeof__default["default"](obj["attributes"]) === "object");
    }
    return result;
  },
  isLink: function isLink(obj) {
    var result = true;
    if (_typeof__default["default"](obj) !== "object" || obj === null) {
      return false;
    } else {
      result = result && typeof obj["e_type"] === "string";
      result = result && typeof obj["from_id"] === "string";
      result = result && typeof obj["from_type"] === "string";
      result = result && typeof obj["to_id"] === "string";
      result = result && typeof obj["to_type"] === "string";
      result = result && typeof obj["directed"] === "boolean";
      result = result && _typeof__default["default"](obj["attributes"]) === "object";
    }
    return result;
  },
  parseNode: function parseNode(obj) {
    var _context3, _context4, _context5;
    var newNode = {
      id: obj.v_id,
      type: obj.v_type,
      attrs: {},
      styles: {},
      others: {
        "vertex set": obj.v_set
      },
      labels: {}
    };
    if (obj.v) {
      var _context;
      _forEachInstanceProperty__default["default"](_context = _Object$keys__default["default"](obj.v)).call(_context, function (attr) {
        newNode.attrs[attr] = obj.v[attr];
      });
    }
    if (obj.attributes) {
      var _context2;
      _forEachInstanceProperty__default["default"](_context2 = _Object$keys__default["default"](obj.attributes)).call(_context2, function (attr) {
        newNode.attrs[attr] = obj.attributes[attr];
      });
    }
    obj.styles = obj.styles || {};
    obj.others = obj.others || {};
    obj.labels = obj.labels || {};
    _forEachInstanceProperty__default["default"](_context3 = _Object$keys__default["default"](obj.styles)).call(_context3, function (key) {
      newNode.styles[key] = obj.styles[key];
    });
    _forEachInstanceProperty__default["default"](_context4 = _Object$keys__default["default"](obj.others)).call(_context4, function (key) {
      newNode.others[key] = obj.others[key];
    });
    _forEachInstanceProperty__default["default"](_context5 = _Object$keys__default["default"](obj.labels)).call(_context5, function (key) {
      newNode.labels[key] = obj.labels[key];
    });
    return newNode;
  },
  parseLink: function parseLink(obj) {
    var _context6, _context7, _context8, _context9;
    var newLink = {
      source: {
        id: obj.from_id,
        type: obj.from_type
      },
      target: {
        id: obj.to_id,
        type: obj.to_type
      },
      directed: obj.directed,
      type: obj.e_type,
      discriminator: "",
      attrs: {},
      styles: {},
      others: {},
      labels: {}
    };
    _forEachInstanceProperty__default["default"](_context6 = _Object$keys__default["default"](obj.attributes)).call(_context6, function (attr) {
      newLink.attrs[attr] = obj.attributes[attr];
    });
    obj.styles = obj.styles || {};
    obj.others = obj.others || {};
    obj.labels = obj.labels || {};
    newLink.discriminator = obj.discriminator || "";
    _forEachInstanceProperty__default["default"](_context7 = _Object$keys__default["default"](obj.styles)).call(_context7, function (key) {
      newLink.styles[key] = obj.styles[key];
    });
    _forEachInstanceProperty__default["default"](_context8 = _Object$keys__default["default"](obj.others)).call(_context8, function (key) {
      newLink.others[key] = obj.others[key];
    });
    _forEachInstanceProperty__default["default"](_context9 = _Object$keys__default["default"](obj.labels)).call(_context9, function (key) {
      newLink.labels[key] = obj.labels[key];
    });
    return newLink;
  }
};
function parseGraph(externalData, discriminatorMap) {
  var targetGraph = {
    nodes: [],
    links: []
  };
  try {
    recursivelyGetExternalElement(externalData, targetGraph, new _Set__default["default"](), new _Set__default["default"](), gquery, discriminatorMap);
  } catch (err) {
    console.warn(err);
    targetGraph = {
      nodes: [],
      links: []
    };
  }
  var patchedGraph = addMissingNode(targetGraph);
  return patchedGraph;
}
function recursivelyGetExternalElement(obj, targetGraph, visitedNodes, visitedLinks, format, discriminatorMap) {
  if (_typeof__default["default"](obj) !== "object" || obj === null) {
    return obj;
  }
  var tempObj = obj.constructor ? obj.constructor() : {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      tempObj[key] = recursivelyGetExternalElement(obj[key], targetGraph, visitedNodes, visitedLinks, format, discriminatorMap);
    } else {
      throw new Error("External Data format can not be parased.");
    }
  }
  if (format.isNode(tempObj)) {
    var _context10;
    var parsedNode = format.parseNode(tempObj);
    var id = _concatInstanceProperty__default["default"](_context10 = "".concat(parsedNode.type, "#")).call(_context10, parsedNode.id);
    if (!visitedNodes.has(id)) {
      visitedNodes.add(id);
      targetGraph.nodes.push(parsedNode);
    }
  }
  if (format.isLink(tempObj)) {
    var parsedLink = format.parseLink(tempObj);
    if (discriminatorMap !== null && discriminatorMap !== void 0 && discriminatorMap[parsedLink.type]) {
      var _discriminatorMap$par;
      parsedLink.discriminator = (_discriminatorMap$par = discriminatorMap[parsedLink.type]) === null || _discriminatorMap$par === void 0 ? void 0 : _mapInstanceProperty__default["default"](_discriminatorMap$par).call(_discriminatorMap$par, function (d) {
        var _parsedLink$attrs;
        return (_parsedLink$attrs = parsedLink.attrs) === null || _parsedLink$attrs === void 0 ? void 0 : _parsedLink$attrs[d];
      }).join(':');
    }
    var _id = graphchart_data_link.getLinkID(parsedLink);
    if (!visitedLinks.has(_id)) {
      visitedLinks.add(_id);
      targetGraph.links.push(parsedLink);
    }
  }
  return tempObj;
}

// edges in graph may have source/target node not in graph
// we try to generate the missing nodes
function addMissingNode(graph) {
  var nodes = graph.nodes,
    links = graph.links;
  var newNodes = _toConsumableArray__default["default"](nodes);
  var vertIdSet = new _Set__default["default"]();
  var _iterator = _createForOfIteratorHelper(nodes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var node = _step.value;
      var id = graphchart_data_node.getNodeID(node);
      vertIdSet.add(id);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(links),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _context11, _context12;
      var link = _step2.value;
      var source = _concatInstanceProperty__default["default"](_context11 = "".concat(link.source.type, "#")).call(_context11, link.source.id);
      var target = _concatInstanceProperty__default["default"](_context12 = "".concat(link.target.type, "#")).call(_context12, link.target.id);
      if (!vertIdSet.has(source)) {
        vertIdSet.add(source);
        newNodes.push({
          id: link.source.id,
          type: link.source.type,
          attrs: {}
        });
      }
      if (!vertIdSet.has(target)) {
        vertIdSet.add(target);
        newNodes.push({
          id: link.target.id,
          type: link.target.type,
          attrs: {}
        });
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return {
    nodes: newNodes,
    links: links
  };
}

exports.addMissingNode = addMissingNode;
exports.parseGraph = parseGraph;
